var map = {
	"./consulting/what-makes-us-different.png": "KPg7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "C+Mu";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/what\-makes\-us\-different\.png$
// module id = C+Mu
// module chunks = 0